import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    margin-top: 75px;
    padding: 0 10px;
    width: 100%;
    @media (min-width: 720px) {
        margin: 40px 0 0 200px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-left: 25px;
    }
`;

export const Title = styled.h1`
    color: #333;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    width: 100%;
`;

export const TitleContainer = styled.div`
    align-self: flex-start;
    display: flex;
    justify-content: center;
    padding-block: 20px;
    width: 100%;
    @media (min-width: 720px) {
        width: 90%;
    }
`;

export const ContainerRow = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    @media (min-width: 1100px) {
        align-items: flex-start;
        flex-direction: row;
        justify-content: flex-start;
    }
`;

export const ContainerColumn = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: flex-start;
    padding: 5px 20px;
    width: 80%;
    @media (min-width: 1100px) {
        width: 30%;
    }
`;

export const ImageIcon = styled.img`
    height: 24px;
    width: 24px;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 25px;
    justify-content: center;
    padding-bottom: 150px;
    width: 100%;
    @media (min-width: 1100px) {
        align-self: flex-end;
        justify-content: space-between;
        margin-right: 10%;
        padding: 20px;
        width: 30%;
    }
`;

export const ContainerMap = styled.div`
    min-height: 100%; 
    position: absolute;
    min-width: 100%;
    z-index: 5;
    border-radius: 15px;
    overflow: hidden;
`;

export const MapButtons = styled.div`
    position: absolute;
    right: ${props => props.$right || 'auto'};
    left: ${props => props.$left || 'auto'};
    bottom: 20px;
    z-index: 10;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
`;

export const MapOptions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 10px;
    width: calc(100% - 15px);
    margin-bottom: 15px;
`;

export const RowContainer = styled.div`
    align-items: center;
    display: flex;
    margin-top: 30px;
    gap: 18px;
    justify-content: center;
`;

export const AreasOptions = styled.div`
    position: absolute;
    right: ${props => props.$right || 'auto'};
    left: ${props => props.$left || 'auto'};
    top: 10px;
    bottom: ${props => props.$bottom || 'auto'};
    z-index: 10;
    display: none;
    flex-direction: column;
    gap: 10px;
    border: ${props => props.border || 'none'};
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.5);
    padding: ${props => props.$selectedOption ? '5px' : '0'};
    transition: 1s;
    max-height: ${props => props.$selectedOption ? 'calc(100% - 95px)' : '0'};
    max-width: ${props => props.$selectedOption ? 'auto' : '0'};
    overflow: ${props => props.$selectedOption ? '' : 'hidden'};
    @media (min-width: 720px) {
        display: flex;
    }
`;

export const AreaSrcoll = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 10px;
    max-width: 270px;
`;

export const AreasTitle = styled.h2`
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
`;

export const BtnIcon = styled(SVG)`
    height: 20px;
    width: 20px;
    & path {
        fill: currentColor;
    }
`;

export const CalendarContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    @media (min-width: 720px) {
        flex-direction: row;
        justify-content: space-between;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        flex-direction: column;
        gap: 20px;  
    }
`;

export const ModalText = styled.div`
    color: #333;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
`;